import commonSlice from '@/state/common/commonSlice'
import triageSlice from '@/state/poa/triageSlice'
import answerSlice from '@/state/survey/answerSlice'
import formInputSlice from '@/state/survey/formInputSlice'
import formSlice from '@/state/survey/formSlice'
import patientSurveySlice from '@/state/survey/patientSuerveySlice'
import poaSurveySlice from '@/state/survey/poaSurveySlice'
import patientAnswerSlice from '@/state/survey/saveAnswerSlice'

import { configureStore, Middleware } from '@reduxjs/toolkit'

const customLogger: Middleware = (storeAPI) => (next) => (action) => {
    console.log('Dispatching action:', action)
    console.log('Previous state:', storeAPI.getState())
    const result = next(action) // Dispatch the action
    return result // Pass the result
}

// Example slice or reducer (you can replace it with your actual slices)
const store = configureStore({
    reducer: {
        form: formSlice,
        answers: answerSlice,
        patientSurvey: patientSurveySlice,
        patientAnswer: patientAnswerSlice,
        poaSurvey: poaSurveySlice,
        common: commonSlice,
        triage: triageSlice,
        inputData: formInputSlice,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }).concat(customLogger),
})

export default store

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
